module.exports = __webpack_public_path__ + "static/media/feature-secure.7a5c1bac.svg";